import { create } from "zustand";

interface AuthState {
  role: number;
  name: string;
  uniqueMemberNo: string;
  kioskCode: string;
  isLoggedIn: boolean;
  setAuth: (data: Omit<AuthState, "setAuth" | "clearAuth" | "isLoggedIn">) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()((set) => ({
  role: Number(localStorage.getItem("user_role")) || 0,
  name: localStorage.getItem("user_name") || "",
  uniqueMemberNo: localStorage.getItem("unique_member_no") || "",
  kioskCode: localStorage.getItem("kiosk_code") || "",
  isLoggedIn: !!localStorage.getItem("access_token"),

  setAuth: (data) => {
    if (data.name) localStorage.setItem("user_name", data.name);
    if (data.uniqueMemberNo) localStorage.setItem("unique_member_no", data.uniqueMemberNo);
    if (data.kioskCode) localStorage.setItem("kiosk_code", data.kioskCode);
    set({ ...data, isLoggedIn: true });
  },

  clearAuth: () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user_role");
    localStorage.removeItem("user_name");
    localStorage.removeItem("unique_member_no");
    localStorage.removeItem("kiosk_code");
    localStorage.removeItem("cms_access_token");
    set({ role: 0, name: "", uniqueMemberNo: "", kioskCode: "", isLoggedIn: false });
  },
}));